module.exports = __webpack_public_path__ + "static/media/Banner_AC2.702736ca.jpg";